// Country list for the vendor dropdown (replaces the restcountries.com API call,
// which was shut down - v3.1 no longer returns data).
//
// value = common country name (same text that was already saved in company_country)
// label = "Name (ISO alpha-3)", same format as before
//
// Data: mledoze/countries via world-countries@5.1.0 (ODbL 1.0)
// https://github.com/mledoze/countries
// 250 entries, sorted A-Z. Countries rarely change, so no API is needed.

const COUNTRIES = [
  ["Afghanistan", "AFG"],
  ["Åland Islands", "ALA"],
  ["Albania", "ALB"],
  ["Algeria", "DZA"],
  ["American Samoa", "ASM"],
  ["Andorra", "AND"],
  ["Angola", "AGO"],
  ["Anguilla", "AIA"],
  ["Antarctica", "ATA"],
  ["Antigua and Barbuda", "ATG"],
  ["Argentina", "ARG"],
  ["Armenia", "ARM"],
  ["Aruba", "ABW"],
  ["Australia", "AUS"],
  ["Austria", "AUT"],
  ["Azerbaijan", "AZE"],
  ["Bahamas", "BHS"],
  ["Bahrain", "BHR"],
  ["Bangladesh", "BGD"],
  ["Barbados", "BRB"],
  ["Belarus", "BLR"],
  ["Belgium", "BEL"],
  ["Belize", "BLZ"],
  ["Benin", "BEN"],
  ["Bermuda", "BMU"],
  ["Bhutan", "BTN"],
  ["Bolivia", "BOL"],
  ["Bosnia and Herzegovina", "BIH"],
  ["Botswana", "BWA"],
  ["Bouvet Island", "BVT"],
  ["Brazil", "BRA"],
  ["British Indian Ocean Territory", "IOT"],
  ["British Virgin Islands", "VGB"],
  ["Brunei", "BRN"],
  ["Bulgaria", "BGR"],
  ["Burkina Faso", "BFA"],
  ["Burundi", "BDI"],
  ["Cambodia", "KHM"],
  ["Cameroon", "CMR"],
  ["Canada", "CAN"],
  ["Cape Verde", "CPV"],
  ["Caribbean Netherlands", "BES"],
  ["Cayman Islands", "CYM"],
  ["Central African Republic", "CAF"],
  ["Chad", "TCD"],
  ["Chile", "CHL"],
  ["China", "CHN"],
  ["Christmas Island", "CXR"],
  ["Cocos (Keeling) Islands", "CCK"],
  ["Colombia", "COL"],
  ["Comoros", "COM"],
  ["Cook Islands", "COK"],
  ["Costa Rica", "CRI"],
  ["Croatia", "HRV"],
  ["Cuba", "CUB"],
  ["Curaçao", "CUW"],
  ["Cyprus", "CYP"],
  ["Czechia", "CZE"],
  ["Denmark", "DNK"],
  ["Djibouti", "DJI"],
  ["Dominica", "DMA"],
  ["Dominican Republic", "DOM"],
  ["DR Congo", "COD"],
  ["Ecuador", "ECU"],
  ["Egypt", "EGY"],
  ["El Salvador", "SLV"],
  ["Equatorial Guinea", "GNQ"],
  ["Eritrea", "ERI"],
  ["Estonia", "EST"],
  ["Eswatini", "SWZ"],
  ["Ethiopia", "ETH"],
  ["Falkland Islands", "FLK"],
  ["Faroe Islands", "FRO"],
  ["Fiji", "FJI"],
  ["Finland", "FIN"],
  ["France", "FRA"],
  ["French Guiana", "GUF"],
  ["French Polynesia", "PYF"],
  ["French Southern and Antarctic Lands", "ATF"],
  ["Gabon", "GAB"],
  ["Gambia", "GMB"],
  ["Georgia", "GEO"],
  ["Germany", "DEU"],
  ["Ghana", "GHA"],
  ["Gibraltar", "GIB"],
  ["Greece", "GRC"],
  ["Greenland", "GRL"],
  ["Grenada", "GRD"],
  ["Guadeloupe", "GLP"],
  ["Guam", "GUM"],
  ["Guatemala", "GTM"],
  ["Guernsey", "GGY"],
  ["Guinea", "GIN"],
  ["Guinea-Bissau", "GNB"],
  ["Guyana", "GUY"],
  ["Haiti", "HTI"],
  ["Heard Island and McDonald Islands", "HMD"],
  ["Honduras", "HND"],
  ["Hong Kong", "HKG"],
  ["Hungary", "HUN"],
  ["Iceland", "ISL"],
  ["India", "IND"],
  ["Indonesia", "IDN"],
  ["Iran", "IRN"],
  ["Iraq", "IRQ"],
  ["Ireland", "IRL"],
  ["Isle of Man", "IMN"],
  ["Israel", "ISR"],
  ["Italy", "ITA"],
  ["Ivory Coast", "CIV"],
  ["Jamaica", "JAM"],
  ["Japan", "JPN"],
  ["Jersey", "JEY"],
  ["Jordan", "JOR"],
  ["Kazakhstan", "KAZ"],
  ["Kenya", "KEN"],
  ["Kiribati", "KIR"],
  ["Kosovo", "UNK"],
  ["Kuwait", "KWT"],
  ["Kyrgyzstan", "KGZ"],
  ["Laos", "LAO"],
  ["Latvia", "LVA"],
  ["Lebanon", "LBN"],
  ["Lesotho", "LSO"],
  ["Liberia", "LBR"],
  ["Libya", "LBY"],
  ["Liechtenstein", "LIE"],
  ["Lithuania", "LTU"],
  ["Luxembourg", "LUX"],
  ["Macau", "MAC"],
  ["Madagascar", "MDG"],
  ["Malawi", "MWI"],
  ["Malaysia", "MYS"],
  ["Maldives", "MDV"],
  ["Mali", "MLI"],
  ["Malta", "MLT"],
  ["Marshall Islands", "MHL"],
  ["Martinique", "MTQ"],
  ["Mauritania", "MRT"],
  ["Mauritius", "MUS"],
  ["Mayotte", "MYT"],
  ["Mexico", "MEX"],
  ["Micronesia", "FSM"],
  ["Moldova", "MDA"],
  ["Monaco", "MCO"],
  ["Mongolia", "MNG"],
  ["Montenegro", "MNE"],
  ["Montserrat", "MSR"],
  ["Morocco", "MAR"],
  ["Mozambique", "MOZ"],
  ["Myanmar", "MMR"],
  ["Namibia", "NAM"],
  ["Nauru", "NRU"],
  ["Nepal", "NPL"],
  ["Netherlands", "NLD"],
  ["New Caledonia", "NCL"],
  ["New Zealand", "NZL"],
  ["Nicaragua", "NIC"],
  ["Niger", "NER"],
  ["Nigeria", "NGA"],
  ["Niue", "NIU"],
  ["Norfolk Island", "NFK"],
  ["North Korea", "PRK"],
  ["North Macedonia", "MKD"],
  ["Northern Mariana Islands", "MNP"],
  ["Norway", "NOR"],
  ["Oman", "OMN"],
  ["Pakistan", "PAK"],
  ["Palau", "PLW"],
  ["Palestine", "PSE"],
  ["Panama", "PAN"],
  ["Papua New Guinea", "PNG"],
  ["Paraguay", "PRY"],
  ["Peru", "PER"],
  ["Philippines", "PHL"],
  ["Pitcairn Islands", "PCN"],
  ["Poland", "POL"],
  ["Portugal", "PRT"],
  ["Puerto Rico", "PRI"],
  ["Qatar", "QAT"],
  ["Republic of the Congo", "COG"],
  ["Réunion", "REU"],
  ["Romania", "ROU"],
  ["Russia", "RUS"],
  ["Rwanda", "RWA"],
  ["Saint Barthélemy", "BLM"],
  ["Saint Helena, Ascension and Tristan da Cunha", "SHN"],
  ["Saint Kitts and Nevis", "KNA"],
  ["Saint Lucia", "LCA"],
  ["Saint Martin", "MAF"],
  ["Saint Pierre and Miquelon", "SPM"],
  ["Saint Vincent and the Grenadines", "VCT"],
  ["Samoa", "WSM"],
  ["San Marino", "SMR"],
  ["São Tomé and Príncipe", "STP"],
  ["Saudi Arabia", "SAU"],
  ["Senegal", "SEN"],
  ["Serbia", "SRB"],
  ["Seychelles", "SYC"],
  ["Sierra Leone", "SLE"],
  ["Singapore", "SGP"],
  ["Sint Maarten", "SXM"],
  ["Slovakia", "SVK"],
  ["Slovenia", "SVN"],
  ["Solomon Islands", "SLB"],
  ["Somalia", "SOM"],
  ["South Africa", "ZAF"],
  ["South Georgia", "SGS"],
  ["South Korea", "KOR"],
  ["South Sudan", "SSD"],
  ["Spain", "ESP"],
  ["Sri Lanka", "LKA"],
  ["Sudan", "SDN"],
  ["Suriname", "SUR"],
  ["Svalbard and Jan Mayen", "SJM"],
  ["Sweden", "SWE"],
  ["Switzerland", "CHE"],
  ["Syria", "SYR"],
  ["Taiwan", "TWN"],
  ["Tajikistan", "TJK"],
  ["Tanzania", "TZA"],
  ["Thailand", "THA"],
  ["Timor-Leste", "TLS"],
  ["Togo", "TGO"],
  ["Tokelau", "TKL"],
  ["Tonga", "TON"],
  ["Trinidad and Tobago", "TTO"],
  ["Tunisia", "TUN"],
  ["Türkiye", "TUR"],
  ["Turkmenistan", "TKM"],
  ["Turks and Caicos Islands", "TCA"],
  ["Tuvalu", "TUV"],
  ["Uganda", "UGA"],
  ["Ukraine", "UKR"],
  ["United Arab Emirates", "ARE"],
  ["United Kingdom", "GBR"],
  ["United States", "USA"],
  ["United States Minor Outlying Islands", "UMI"],
  ["United States Virgin Islands", "VIR"],
  ["Uruguay", "URY"],
  ["Uzbekistan", "UZB"],
  ["Vanuatu", "VUT"],
  ["Vatican City", "VAT"],
  ["Venezuela", "VEN"],
  ["Vietnam", "VNM"],
  ["Wallis and Futuna", "WLF"],
  ["Western Sahara", "ESH"],
  ["Yemen", "YEM"],
  ["Zambia", "ZMB"],
  ["Zimbabwe", "ZWE"],
];

const countryOptions = COUNTRIES.map(([name, code]) => ({
  value: name,
  label: `${name} (${code})`,
}));

export default countryOptions;
